module.exports = __webpack_public_path__ + "static/media/pic_heizuan.4e979db2.png";